import { Button, Col, Divider, Form, Image, Modal, Row, Space } from "antd";
import React, { useEffect, useState } from "react";

import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as String from "../commons/string";
import * as Common from "../commons/common";
import * as Utils from "../utils/utils";

import styles from "../pages/RentInfo.module.css";

function RentUserDetail({ user, additionalDriverMode }: { user: Types.UserDto; additionalDriverMode?: boolean }) {
    const [openModal, setOpenModal] = useState<boolean>(false);

    const displayModalContents = () => {
        return (
            <Form layout="inline" style={{ border: "solid 1px #DBDFE5" }}>
                <Row>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                        <Form.Item className="searchForm" label="이메일">
                            <span>{user.email ? user.email : String.dash}</span>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                        <Form.Item className="searchForm" label="주소">
                            <span>
                                {user.address || user.addressDetails
                                    ? (user.address && user.address) + " " + (user.addressDetails && user.addressDetails)
                                    : String.dash}
                            </span>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                        <Form.Item className="searchForm" label="회사명">
                            <span>{user.companyName ? user.companyName : String.dash}</span>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                        <Form.Item className="searchForm searchLastRow" label={<span style={{ wordBreak: "keep-all" }}>사업자 등록번호</span>}>
                            <span>{user.companyRegistrationNo ? user.companyRegistrationNo : String.dash}</span>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        );
    };

    return (
        <>
            {user && (
                <Space direction="vertical" size={10} style={{ width: "100%" }}>
                    <Row align={"middle"} justify={"space-between"}>
                        <Col flex={"auto"}>
                            <Divider className={styles.subTitle} orientation="left">
                                <span>{additionalDriverMode ? "추가 운전자 정보" : "예약자 정보"}</span>
                            </Divider>
                        </Col>
                        <Col flex={0.1} style={{ textAlign: "right" }}>
                            <span onClick={() => setOpenModal(true)} style={{ color: "var(--text-highlight)", fontSize: "16px" }}>
                                상세보기
                            </span>
                        </Col>
                    </Row>

                    <Form layout="inline" style={{ border: "solid 1px #DBDFE5" }}>
                        <Row>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" label="이름">
                                    <span>{user.name ? user.name : String.dash}</span>
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" label="연락처">
                                    <span onClick={() => user.phone && (location.href = "tel:" + user.phone)}>
                                        {user.phone ? user.phone : String.dash}
                                    </span>
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm" label="면허종류">
                                    <span>{user.driverLicense?.licenseType ? user.driverLicense?.licenseType : String.dash}</span>
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                                <Form.Item className="searchForm searchLastRow" label="면허번호">
                                    <span>{user.driverLicense?.licenseNumber ? user.driverLicense?.licenseNumber : String.dash}</span>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Space>
            )}
            {openModal && (
                <Modal centered title="예약자 부가 정보" open={openModal} footer={<Button onClick={() => setOpenModal(false)}>확인</Button>}>
                    {displayModalContents()}
                </Modal>
            )}
        </>
    );
}

export default RentUserDetail;
